<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select
      v-model="query.siteId"
      size="small"
      style="width:120px;"
    >
      <el-option
        v-for="site in filterSites"
        :key="site.id"
        :value="site.id"
        :label="site.name"
      />
    </el-select>

    <factor-tree-query ref="factor-tree" :factor-tree="factorTree" :query="query" />

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>

    <el-button
      :disabled="dataList.length === 0"
      type="success"
      size="small"
      icon="el-icon-download"
      @click="onDownloadBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <div class="head-wapper">
          <div class="flag-info">
            <div v-for="(item, i) in dasFlagList" :key="i">{{ item.id }}: {{ item.name }}</div>
          </div>
          <div class="tools">
            <unit-switch
              :default-unit-prop.sync="unitProp"
              @change="onUnitPropChange"
            />

            <display-type
              :default-display-type.sync="displayType"
              style="margin-left:20px;"
              @change="onDisplayTypeChanged"
            />
          </div>
        </div>
      </template>

      <data-table
        v-if="displayType === 1"
        ref="dataTable"
        :key="dataTableKey"
        :columns="tableColumns"
        :data="tableDataList"
        :pagination="pagination"
        selected-style
      />

      <template v-else>
        <dimension-weather-chart-v2
          v-for="data in dataList"
          v-if="data.dimensions.length > 0"
          :key="data.id"
          :data-config="data"
          :dimension="dimension"
          :unit-prop="unitProp"
          :download-name="downloadName"
          :max-legend-num="5"
          style="flex:1 0 100%;"
        />
        <!-- <category-factor-chart-group
          v-for="data in dataList"
          v-if="data.dimensions.length > 0"
          :key="data.id"
          :factor-group-map="factorGroupMap"
          :data-config="data"
          :unit-prop="unitProp"
        /> -->
      </template>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../BaseSiteFactorData'
// import DataFormatter from '../../../model/DataFormatter'
import LayoutContent from '../../../components/Layout/Content'
import DataTimeQuery from '../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../components/Data/DataWrapper'
import UnitSwitch from '../../../components/Data/UnitSwitch'
import DisplayType from '../../../components/Data/DisplayType'
import DimensionType from '../../../components/Data/DimensionType'
// import CategoryFactorChartGroup from '../../../components/Data/ChartWrapper/CategoryFactorChartGroup'
import DimensionWeatherChartV2 from '../../../components/Data/ChartWrapper/DimensionWeatherChartV2'
import DeviceCategoryConfig from '../../../model/DeviceCategoryConfig'
import unitConverter from '../../../utils/unitConverter'

const DIMENSION_CONFIGS = [{
  id: 'siteName',
  label: '站房',
  showUnit: true
}, {
  id: 'factorName',
  label: '因子',
  showUnit: false
}]

export default {
  name: 'RealTimeData',
  routeInfo: {
    label: '实时数据',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, UnitSwitch, DisplayType, DimensionType, DimensionWeatherChartV2},
  data: () => ({
    query: {
      factorIds: [],
      siteId: ''
    },
    displayType: 2,
    dataTableKey: 0,
    normalData: [],
    tableColumns: Object.freeze([]),
    tableDataList: Object.freeze([]),
    pagination: {
      no: 1,
      size: 60
    },
    unitDataObj: {}
  }),
  computed: {
    isSetAllFactorIds: () => false,
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HEAVY_METAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SPAMS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.LIGHT_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ORGANIC_SULFUR_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GONG_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SUN_RADIATION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GREENHOUSE_GAS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ULTRAVIOLET_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PHOTOLYSIS_RATE_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NEGATIVE_OXYGEN_ION_DEVICE_CATEGORY, false)
      ]
    },
    downloadName: () => '原始数据',
    currentDimensions () {
      return Object.values(this.dataList.reduce((map, dataConfig) => dataConfig.dimensions.reduce((map, dimension) => {
        let dimensionId = dimension.id

        if (!map[dimensionId]) {
          map[dimensionId] = dimension
        }

        return map
      }, map), {}))
    },
    _factorTree () {
      if (this.query.siteId === '') {
        return []
      }
      let factorGroupMap = JSON.parse(JSON.stringify(this.formatFactorGroupMap))
      let roots = []
      let filterFactors = [...new Set(this.filterSiteMap[this.query.siteId].devices.map(el => el.siteDeviceFactors).flat())].map(el => {
        return {
          ...el,
          id: el.factorId
        }
      })

      for (let i = 0; i < filterFactors.length; i++) {
        let factor = filterFactors[i]
        let {parentId} = factor
        let parent = factorGroupMap[parentId]

        if (parent) {
          let {children} = parent

          if (!Array.isArray(children)) {
            children = parent.children = []
            filterFactors.splice(i + 1, 0, parent)
          }

          children.push(factor)
        } else {
          roots.push(factor)
        }
      }

      return roots
    },
    dasFlagList () {
      return [{
        id: 'N',
        name: '正常'
      }, {
        id: 'P',
        name: '停电有效'
      }, {
        id: 'p',
        name: '停电无效'
      }, {
        id: 'C',
        name: '校准有效'
      }, {
        id: 'c',
        name: '校准无效'
      }, {
        id: 'M',
        name: '维护有效'
      }, {
        id: 'm',
        name: '停电无效'
      }, {
        id: 'B',
        name: '故障有效'
      }, {
        id: 'b',
        name: '故障无效'
      }, {
        id: 'L',
        name: '超量程下限有效'
      }, {
        id: 'l',
        name: '超量程下限无效'
      }, {
        id: 'H',
        name: '超量程上限有效'
      }, {
        id: 'h',
        name: '超量程上限无效'
      }, {
        id: 'D',
        name: '缺失有效'
      }, {
        id: 'd',
        name: '缺失无效'
      }]
    }
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let factorId = dimensionIds[dimension ^ 1]
      return {
        type: factorId === '1011' ? 'bar' : 'line',
        showSymbol: false
      }
    },
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length === 0) {
        return
      }

      let {query: {siteId}} = this
      delete this.query.isAuditCompleted
      delete this.query.isGetInvalidData
      delete this.query.isMultipleIntegral
      delete this.query.siteIds
      delete this.query.dataType

      if (siteId === '') {
        this.query.siteId = filterSites[0].id
      }

      this.afterSetSiteIds()
    },
    setCurrentQuery () {
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(this.query)))
    },
    getData () {
      this.changeLoadStatus(true)
      const {currentQuery} = this

      const requests = [
        this.$api.Data.getRealTimeData(currentQuery)
      ]

      Promise.all(requests).then(([data]) => {
        this.normalData = Object.freeze(data)
        this.unitDataObj = {}
        this.formatData(data)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onUnitPropChange () {
      if (this.unitDataObj[this.unitProp]) {
        let data = this.unitDataObj[this.unitProp]
        this.dataList = Object.freeze(data.dataList)
        this.totalDataTimes = Object.freeze(data.totalDataTimes)
      } else {
        this.formatData(this.normalData)
      }
    },
    formatData (backData) {
      let newBackData = this.formatWeatherDataList(backData)
      let currentQuery = JSON.parse(JSON.stringify(this.currentQuery))
      currentQuery.siteIds = [currentQuery.siteId]

      if (Object.keys(currentQuery).length === 0) {
        return
      }
      const {valueProp = 'value'} = this
      const {filterSiteMap} = this
      // const auditRuleFlagMap = {...(this.auditRuleFlagMap || {}), N: {name: '正常'}, X: {name: '数采标记异常'}}
      // const DAS_FLAG_MAP = [
      //   ['P', '停电'],
      //   ['C', '校准'],
      //   ['M', '维护'],
      //   ['B', '故障'],
      //   ['L', '超量程下限'],
      //   ['H', '超量程上限'],
      //   ['D', '缺失']
      // ].reduce((map, [flag, desc]) => {
      //   map[flag] = `${desc}有效`
      //   map[flag.toLocaleLowerCase()] = `${desc}无效`
      //   return map
      // }, {
      //   N: '正常'
      // })

      let tmpList = Object.freeze(newBackData.concat(Object.values(this.noDataReasonMap).reduce((list, noDataReason) => {
        const {siteId} = noDataReason
        const siteConfig = filterSiteMap[siteId]

        if (siteConfig) {
          const {siteDeviceId} = noDataReason
          const siteDeviceConfig = siteConfig.devices.find(siteDevice => siteDevice.id === siteDeviceId)

          if (siteDeviceConfig) {
            const {reason} = noDataReason
            const dataTime = `${noDataReason.dataTime}:00:00`
            siteDeviceConfig.siteDeviceFactors.forEach((siteDeviceFactor) => {
              list.push({
                dataTime,
                siteId,
                siteDeviceId,
                factorId: siteDeviceFactor.factorId,
                auditComment: reason,
                isAuditCompleted: true
              })
            })
          }
        }

        return list
      }, [])).sort((a, b) => a.dataTime.localeCompare(b.dataTime)))

      this.format(currentQuery, 'factorId', (data, newData, dimensionIdProp1, ts, dataTime) => {
        let value = data[valueProp]
        let series = newData.seriesMap[data[dimensionIdProp1]]

        if (series) {
          const displayFlags = []

          if (data.isHaveIntegral) {
            displayFlags.push('重积分')
          } else if (Number.isFinite(value)) {
            const {flag} = data

            if (flag) {
              displayFlags.push(flag.split('|').map(flag => {
                // const flagRule = auditRuleFlagMap[flag]
                // return flagRule ? flagRule.name : flag

                return flag
              }).join('|'))
            }
          }

          if (data.isAuditCompleted && (this.currentQuery.isAuditCompleted || this.currentQuery.isFuse)) {
            const {auditComment} = data

            if (auditComment) {
              displayFlags.push(auditComment)
            }
          }

          const newDataItem = {
            ...data,
            ts,
            dataTime,
            flag: data.flag || null,
            dasFlag: data.dasFlag || null,
            displayFlag: displayFlags.join(',')
          }

          if (data.auditFlag === 'DELETE' && (this.currentQuery.isAuditCompleted || this.currentQuery.isFuse)) {
            delete newDataItem.value
            newDataItem.noDataReason = newDataItem.auditComment
          } else if (Number.isFinite(value)) {
            newDataItem.value = value
          } else {
            newDataItem.noDataReason = newDataItem.auditComment || ''
          }

          series.push(newDataItem)
        }
      }, tmpList, 'dataList')
    },
    format (currentQuery, otherDimensionProp, formatter, oDataListProp, dataListProp) {
      let {dimension} = this
      let otherDimension = dimension ^ 1

      let dimensionIdProps = new Array(2)
      dimensionIdProps[dimension] = 'siteId'
      dimensionIdProps[otherDimension] = otherDimensionProp
      let [dimensionIdProp0, dimensionIdProp1] = dimensionIdProps

      let dimensionIds = new Array(2)
      dimensionIds[dimension] = [currentQuery.siteId]
      dimensionIds[otherDimension] = currentQuery.factorIds
      let [dimensionIds0, dimensionIds1] = dimensionIds

      let {siteFactorMap, factorSiteMap} = this
      let dimensionObjects = new Array(2)
      dimensionObjects[dimension] = siteFactorMap
      dimensionObjects[otherDimension] = factorSiteMap
      let dimensionObjectMap = dimensionObjects[0]

      let tmpList = oDataListProp
      let {completeAllData} = this
      let beginTS = new Date(currentQuery.beginTime).getTime()
      let dataList = Object.values(tmpList.reduce((map, data) => {
        let newData = map[data[dimensionIdProp0]]

        if (newData) {
          let {dataTime} = data
          let ts = new Date(dataTime).getTime()

          if (ts > newData.endTS) {
            newData.endTS = ts
          }

          formatter(data, newData, dimensionIdProp1, ts, dataTime)
        }

        return map
      }, dimensionIds0.reduce((map, dimensionId) => {
        let dimensionObject = dimensionObjectMap[dimensionId]
        let subDimensionMap = dimensionObject.map
        let seriesDimensions = dimensionIds1.reduce((list, id) => {
          let dimensionObj = subDimensionMap[id]

          if (dimensionObj) {
            list.push(dimensionObj)
          }

          return list
        }, [])

        map[dimensionId] = {
          id: dimensionId,
          name: dimensionObject.name,
          beginTS,
          endTS: completeAllData ? new Date(currentQuery.endTime).getTime() : beginTS,
          dimensions: seriesDimensions,
          selectedNames: dimensionObject.selectedNames,
          seriesMap: seriesDimensions.reduce((map, seriesDimension) => {
            map[seriesDimension.id] = []
            return map
          }, {})
        }

        return map
      }, {})))

      let {unitProp} = this
      console.time(666)
      let data = Object.freeze(this.completeAndUnitConvert60(dataList, unitProp))
      console.timeEnd(666)
      this.unitDataObj[unitProp] = data
      this.totalDataTimes = Object.freeze(data.totalDataTimes)
      this[dataListProp] = Object.freeze(data.dataList)
    },
    completeAndUnitConvert60 (dataList, unitProp) {
      let dataListLen = dataList.length
      let totalDataTimeMap = {}

      for (let i = 0; i < dataListLen; i++) {
        let data = dataList[i]
        let {beginTS, endTS, dimensions, seriesMap} = data
        let dimensionsLen = dimensions.length
        let dataTimeMap = {}

        for (let j = 0; j < dimensionsLen; j++) {
          let dimension = dimensions[j]
          let {id, stdUnit, molecular} = dimension
          let displayUnit = dimension[unitProp]
          let dataMap = {}
          let seriesData = seriesMap[id]
          let seriesDataIndex = 0

          let interval = 60000
          let _beginTS = seriesData.length > 0 ? seriesData[0].ts : beginTS
          let beginTS2 = _beginTS - interval

          while (beginTS2 >= beginTS) {
            let date = new Date(beginTS2)
            let dataTime = date.format('YYYY/MM/DD HH:mm:ss')
            dataTimeMap[beginTS2] = totalDataTimeMap[beginTS2] = dataTime
            beginTS2 -= interval
          }

          while (_beginTS <= endTS) {
            let currentData = seriesData[seriesDataIndex]

            if (currentData) {
              let {ts, dataTime} = currentData

              while (_beginTS < ts) {
                let date = new Date(_beginTS)
                let dataTime = date.format('YYYY/MM/DD HH:mm:ss')

                dataTimeMap[_beginTS] = totalDataTimeMap[_beginTS] = dataTime
                _beginTS += interval
              }

              if (currentData && Number.isFinite(currentData.value)) {
                currentData.value = Number(unitConverter(currentData.value, stdUnit, displayUnit, molecular).toFixed(3))
              }

              dataMap[dataTime] = currentData

              dataTimeMap[ts] = totalDataTimeMap[ts] = dataTime
              _beginTS = ts
              seriesDataIndex++
            } else {
              let date = new Date(_beginTS)
              let dataTime = date.format('YYYY/MM/DD HH:mm:ss')
              dataTimeMap[_beginTS] = totalDataTimeMap[_beginTS] = dataTime
            }

            _beginTS += interval
          }

          seriesMap[id] = dataMap
        }

        data.dataTimes = Object.entries(dataTimeMap).map(dataTimes => [Number(dataTimes[0]), dataTimes[1]]).sort((a, b) => a[0] - b[0])
      }

      return {
        dataList,
        totalDataTimes: Object.entries(totalDataTimeMap).map(dataTimes => [Number(dataTimes[0]), dataTimes[1]]).sort((a, b) => a[0] - b[0])
      }
    },
    formatWeatherDataList (dataList) {
      let {siteFactorMap, currentQuery} = this
      let factorIds = currentQuery.factorIds.filter(factorId => /^101(2|3)$/.test(factorId))

      if (factorIds.length === 2) {
        let siteDataMap = [currentQuery.siteId].reduce((map, siteId) => {
          let factorMap = siteFactorMap[siteId].map
          let windSpeed = factorMap['1012']

          if (windSpeed) {
            let windDir = factorMap['1013']

            if (windDir) {
              map[siteId] = {}
            }
          }

          return map
        }, {})

        let dataListLen = dataList.length

        for (let i = 0; i < dataListLen; i++) {
          let data = dataList[i]
          let siteData = siteDataMap[data.siteId]

          if (siteData && data.factorId === '1012') {
            siteData[data.dataTime] = data
          }
        }

        for (let i = 0; i < dataListLen; i++) {
          let data = dataList[i]
          let siteData = siteDataMap[data.siteId]

          if (siteData && data.factorId === '1013') {
            let {dataTime} = data
            let windSpeedData = siteData[dataTime]

            if (windSpeedData) {
              let {value} = data
              windSpeedData.symbolRotate = 180 - value
              windSpeedData.windDirect = value
              windSpeedData.windDirectDisplayFlag = data.dasFlag
            }
          }
        }
      }

      return dataList
    },
    onDownloadBtnClick () {
      this.changeLoadStatus(true)
      const {currentQuery} = this

      const requests = [
        this.$api.Data.exportRealTimeData(currentQuery)
      ]

      Promise.all(requests).then(([data]) => {
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onDisplayTypeChanged (displayType) {
      if (displayType === 1) {
        setTimeout(() => {
          this.$refs.dataTable.doLayout()
        }, 0)
      }
    },
    onDimensionChanged () {
      this.formatData()
    }
  },
  watch: {
    dataList (dataList) {
      let {unitProp} = this
      let dimensionConfig = DIMENSION_CONFIGS[this.dimension]
      let {showUnit} = dimensionConfig

      this.tableColumns = Object.freeze(this.currentDimensions.reduce((tableColumns, factor) => {
        let unit = factor[unitProp]
        tableColumns.push({
          id: factor.id,
          name: `${factor.name}${showUnit && unit ? `(${unit})` : ''}`,
          width: 200,
          align: 'left'
        })
        return tableColumns
      }, [{
        id: 'dataTime',
        name: '时间',
        width: 160,
        align: 'left',
        fixed: true
      }, {
        id: dimensionConfig.id,
        name: dimensionConfig.label,
        width: 160,
        align: 'left',
        fixed: true
      }]))

      this.tableDataList = Object.freeze(dataList.reduce((list, dataConfig) => {
        let {name, dimensions, seriesMap} = dataConfig
        return dataConfig.dataTimes.reduce((list, dataTimeObj) => {
          let dataTime = dataTimeObj[1]
          list.push(dimensions.reduce((formatData, dimension) => {
            let dimensionId = dimension.id
            let seriesItem = seriesMap[dimensionId]
            let data = seriesItem[dataTime]

            if (data) {
              const {value, displayFlag} = data
              formatData[dimensionId] = Number.isFinite(value) ? `${value}${displayFlag ? `(${displayFlag})` : ''}` : (displayFlag || '--')
            } else {
              formatData[dimensionId] = '--'
            }

            return formatData
          }, {
            [dimensionConfig.id]: `${name}${!showUnit && dimensions[0] && dimensions[0][unitProp] ? `(${dimensions[0][unitProp]})` : ''}`,
            dataTime
          }))
          return list
        }, list)
      }, []))

      if (this.displayType !== 1) {
        return
      }

      this.pagination.no = 1

      setTimeout(() => {
        this.$refs.dataTable.doLayout()
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-content-wrapper {
  /deep/ {
    .layout-content-body {
      .layout-content-body-inner {
        overflow: hidden !important;
      }
    }
  }

  .data-wrapper /deep/ .data-wrapper-header {
    height: 120px;
  }
}

.integral-data {
  color: #409EFF;
}

.head-wapper {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 12px;

  .flag-info {
    display: grid;
    grid-template-columns: repeat(8, max-content);
    padding: 6px;
    border-radius: 20px;
    background-color: rgba(239, 239, 239, 0.6);
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.55);

    > div {
      font-size: 14px;
      padding: 0.2rem 0.4rem;
      margin: .2rem;
      border-right: 1px solid rgba(0, 0, 0, 0.15);
      text-align: left;
    }

    div:last-child {
      border: none;
    }

    div:nth-child(8n + 8) {
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/05RealTimeData/index.vue